export default {
  ADD_ITEM(state, item) {
    state.list.unshift(item)
  },
  SET_LIST(state, list) {
    state.list = list
  },
  UPDATE_ADDRESS(state, record) {
      const productIndex = state.list.findIndex((p) => p.id == record.id)
      Object.assign(state.list[productIndex], record)
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.list.findIndex((p) => p.id == itemId)
      state.list.splice(ItemIndex, 1)
  },
}
